export enum CHARGER_TYPE {
    TYPE1 = "type1",
    TYPE2 = "type2",
    RAPID = "rapid",
}
